import { Button, EmptyState } from '@gymcoach/ui';
import { Link } from 'react-router-dom';

/**
 * Not found. Also what a person sees for a screen their role cannot use (RequireRole):
 * the CRM does not confirm that a screen, or a record, exists for someone else.
 */
export function NotFoundPage() {
  return (
    <EmptyState
      title="Not found"
      description="This page does not exist."
      action={
        <Link to="/">
          <Button variant="secondary">Go to the dashboard</Button>
        </Link>
      }
    />
  );
}
